import React from 'react';
import {
    Row,
    Col,
    Button,
    FormGroup,
    Label,
    Modal,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Alert,
    Tooltip
} from 'reactstrap';
import { AvForm } from 'availity-reactstrap-validation';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useState } from 'react';
import { locationEnum } from '../Utility/Enumerator';

const SurveyFilterModal = ({
    filterError,
    modalOpenState,
    closeModalHandler,
    dateFilter,
    setDateFilter,
    statusFilter,
    setStatusFilter,
    applyFilters,
    resetFilters,
    nameFilter,
    setNameFilter,
    emailFilter,
    setEmailFilter,
    phoneFilter,
    setPhoneFilter,
    yearFilter,
    setYearFilter,
    gradeFilter,
    setGradeFilter,
    addressLocationFilter,
    setAddressLocationFilter,
    paymentYearFilter,
    setPaymentYearFilter,
    paymentStatusFilter,
    setPaymentStatusFilter,
    createdByAdminFilter,
    setCreatedByAdminFilter
}) => {

    const[tooltipOpen, setTooltipOpen] = useState(false);
    const toggleTooltip = () => setTooltipOpen(!tooltipOpen);


    const handleDateChange = (dates) => {
        if (dates === null) {
            setDateFilter({ startDate: null, endDate: null });
        } else if (Array.isArray(dates)) {
            setDateFilter({
                startDate: dates[0],
                endDate: dates[1]
            });
        }
    };

    return (
        <React.Fragment>
            <Modal isOpen={modalOpenState} backdrop="static" size="md">
                <ModalHeader toggle={closeModalHandler}>Filter Surveys</ModalHeader>
                <ModalBody>
                    {filterError && (
                        <Alert color="danger" role="alert">
                            <i className="mdi mdi-block-helper mr-2"></i>
                            {filterError}
                        </Alert>
                    )}
                    <AvForm className="needs-validation">
                        <Row>
                            {/* <Col md="12">
                                <FormGroup>
                                    <Label>Date Range</Label>
                                    <DatePicker
                                        selected={dateFilter.startDate}
                                        onChange={handleDateChange}
                                        startDate={dateFilter.startDate}
                                        endDate={dateFilter.endDate}
                                        selectsRange
                                        dateFormat="dd-MM-yyyy"
                                        isClearable={true}
                                        placeholderText="Select a date range"
                                    />
                                </FormGroup>
                            </Col> */}
                            <Col md="12">
                                <FormGroup>
                                    <Label>Status</Label>
                                    <select
                                        className="form-control"
                                        value={statusFilter}
                                        onChange={(e) => setStatusFilter(e.target.value)}
                                    >
                                        <option value="">All</option>
                                        <option value="in-progress">In Progress</option>
                                        <option value="completed">Completed</option>
                                    </select>
                                </FormGroup>
                            </Col>

                            <Col md="12">
                                <FormGroup>
                                    <Label>Name</Label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={nameFilter}
                                        onChange={(e) => setNameFilter(e.target.value)}
                                        placeholder="Search by name"
                                    />
                                </FormGroup>
                            </Col>

                            <Col md="12">
                                <FormGroup>
                                    <Label>Email</Label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={emailFilter}
                                        onChange={(e) => setEmailFilter(e.target.value)}
                                        placeholder="Search by email"
                                    />
                                </FormGroup>
                            </Col>

                            <Col md="12">
                                <FormGroup>
                                    <Label>Phone</Label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={phoneFilter}
                                        onChange={(e) => setPhoneFilter(e.target.value)}
                                        placeholder="Search by phone number"
                                    />
                                </FormGroup>
                            </Col>

                            <Col md="12">
                                <FormGroup>
                                    <Label>Year</Label>
                                    <select
                                        className="form-control"
                                        value={yearFilter}
                                        onChange={(e) => setYearFilter(e.target.value)}
                                    >
                                        <option value="">All</option>
                                        <option value="Half Year">Half Year</option>
                                        <option value="Full Year">Full Year</option>
                                    </select>
                                </FormGroup>
                            </Col>

                            <Col md="12">
                                <FormGroup>
                                    <Label>Grade</Label>
                                    <select
                                        className="form-control"
                                        value={gradeFilter}
                                        onChange={(e) => setGradeFilter(e.target.value)}
                                    >
                                        <option value="">All</option>
                                        <option value="Playgroup">Playgroup</option>
                                        <option value="Nursery">Nursery</option>
                                        <option value="Junior KG">Junior KG</option>
                                        <option value="Senior KG">Senior KG</option>
                                        <option value="Grade 1">Grade 1</option>
                                        <option value="Grade 2">Grade 2</option>
                                        <option value="Grade 3">Grade 3</option>
                                        <option value="Grade 4">Grade 4</option>
                                        <option value="Grade 5">Grade 5</option>
                                    </select>
                                </FormGroup>
                            </Col>

                            <Col md="12">
                                <FormGroup>
                                    <Label>Address Location</Label>
                                    <select
                                        className="form-control"
                                        value={addressLocationFilter}
                                        onChange={(e) => setAddressLocationFilter(e.target.value)}
                                    >
                                        <option value="">All</option>
                                        {locationEnum.map((location) => (
                                            <option key={location.value} value={location.value}>
                                                {location.label}
                                            </option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>

                            <Col md="12">
                                <FormGroup>
                                    <Label>Payment Year</Label>
                                    <select
                                        className="form-control"
                                        value={paymentYearFilter}
                                        onChange={(e) => setPaymentYearFilter(e.target.value)}
                                    >
                                        <option value="">Select Year</option>
                                        {Array.from({ length: 5 }, (_, i) => {
                                            const year = new Date().getFullYear() + i;
                                            return <option key={year} value={year}>{year}</option>;
                                        })}
                                    </select>
                                </FormGroup>
                            </Col>

                            <Col md="12">
                                <FormGroup>
                                    <Label>Payment Status</Label>
                                    <select
                                        className="form-control"
                                        id="paymentStatusTooltip" 
                                        value={paymentStatusFilter}
                                        onChange={(e) => setPaymentStatusFilter(e.target.value)}
                                        disabled={!paymentYearFilter}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="paid">Paid</option>
                                        <option value="unpaid">Unpaid</option>
                                    </select>
                                </FormGroup>
                                {!paymentYearFilter && (
                                    <Tooltip
                                        placement="top"
                                        isOpen={tooltipOpen}
                                        target="paymentStatusTooltip"
                                        toggle={toggleTooltip}
                                    >
                                        Please select Payment Year first
                                    </Tooltip>
                                )}
                            </Col>
                            <Col md="12">
                                <FormGroup>
                                    <Label>Created By Admin</Label>
                                    <select
                                        className="form-control"
                                        value={createdByAdminFilter}
                                        onChange={(e) => setCreatedByAdminFilter(e.target.value)}
                                    >
                                        <option value="">All</option>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                    </select>
                                </FormGroup>
                            </Col>
                        </Row>
                        <ModalFooter>
                            <Button size="sm" color="primary" onClick={applyFilters}>
                                Apply Filter
                            </Button>
                            <Button size="sm" color="success" onClick={resetFilters}>
                                Reset
                            </Button>
                            <Button size="sm" color="light" onClick={closeModalHandler}>
                                Close
                            </Button>
                        </ModalFooter>
                    </AvForm>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default SurveyFilterModal;
